export default __webpack_public_path__ + "assets/tags.9579ef7d94bd34990e0ee6f0241d18a7.png";